import ButtonGroup from '@/components/ButtonGroup'
import { Button, ButtonText } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import {
  ChevronDoubleLeftIcon,
  ChevronDownIcon,
  PlusCircleIcon,
} from '@heroicons/react/16/solid'
import { BoxIcon } from 'lucide-react'

export default function Buttons() {
  return (
    <div className="my-4">
      <h2>Grouped Buttons - NEW</h2>

      <div className="my-4 grid gap-4">
        <ButtonGroup>
          <Button variant="outline">
            <PlusCircleIcon />
            <ButtonText>Button</ButtonText>
          </Button>
          <Button variant="outline">
            <ButtonText>Button</ButtonText>
          </Button>
          <Button variant="outline">
            <ButtonText>Button</ButtonText>
          </Button>
        </ButtonGroup>

        <ButtonGroup>
          <Button>
            <PlusCircleIcon />
            <ButtonText>Button</ButtonText>
          </Button>
          <Button>
            <ButtonText>Button</ButtonText>
          </Button>
          <Button>
            <ButtonText>Button</ButtonText>
          </Button>
        </ButtonGroup>

        <ButtonGroup>
          <Button variant="outline">
            <PlusCircleIcon />
            <ButtonText>Button</ButtonText>
          </Button>
          <Button>
            <ButtonText>Button</ButtonText>
          </Button>
          <Button>
            <ButtonText>Button</ButtonText>
          </Button>
        </ButtonGroup>

        <ButtonGroup>
          <Button variant="outline">
            <ChevronDoubleLeftIcon />
            <ButtonText>Show Previous: 1 week</ButtonText>
          </Button>
          <DropdownMenu>
            {/* Important to add asChild */}
            <DropdownMenuTrigger asChild>
              <Button iconOnly type="button" variant="outline">
                <ChevronDownIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[220px]">
              <DropdownMenuItem>Add New Vault</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </ButtonGroup>
      </div>

      <h2>Buttons</h2>
      <div className="h- flex  flex-wrap gap-3 ">
        <Button size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button iconOnly>
          <BoxIcon />
        </Button>

        <Button size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button>
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
        <Button dropdown>
          <ButtonText>Dropdown</ButtonText>
        </Button>
        <Button dropdown>
          <BoxIcon className="" />
          <ButtonText>Dropdown</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button size="lg" loading>
          <ButtonText>Button-lg-ld</ButtonText>
        </Button>

        <Button size="lg" loading iconOnly>
          {/* Hide the original icon if it is loading <BoxIcon /> */}
        </Button>

        <Button disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* secondary */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="secondary" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="secondary" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="secondary" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="secondary" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="secondary" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="secondary" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="secondary">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="secondary" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="secondary" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="secondary" size="lg" loading iconOnly></Button>

        <Button variant="secondary" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="secondary" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="secondary" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button variant="secondary" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="secondary" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* Secondary end */}
      <h2>outline</h2>
      {/* outline */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="outline" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="outline" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="outline" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="outline" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="outline" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="outline" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="outline">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="outline" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="outline" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="outline" size="lg" loading iconOnly></Button>

        <Button variant="outline" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="outline" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="outline" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button variant="outline" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="outline" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* outline end */}

      <p>Ghost</p>
      {/* Ghost */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="ghost" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="ghost" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="ghost" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="ghost" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="ghost" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="ghost" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="ghost">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="ghost" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="ghost" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="ghost" size="lg" loading iconOnly></Button>

        <Button variant="ghost" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="ghost" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="ghost" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button variant="ghost" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="ghost" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* Ghost end */}

      <p className="bg-red-200">destructive</p>
      {/* destructive */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="destructive" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructive" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructive" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructive" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructive" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructive" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="destructive">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructive" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructive" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructive" size="lg" loading iconOnly></Button>

        <Button variant="destructive" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructive" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructive" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button variant="destructive" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructive" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* destructive end */}

      <p className="bg-red-200">destructive outline</p>
      {/* destructive outline */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="destructiveOutline" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructiveOutline" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructiveOutline" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveOutline" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveOutline" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveOutline" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="destructiveOutline">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveOutline" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructiveOutline" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button
          variant="destructiveOutline"
          size="lg"
          loading
          iconOnly
        ></Button>

        <Button variant="destructiveOutline" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveOutline" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructiveOutline" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button variant="destructiveOutline" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveOutline" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* destructive end */}

      <p className="bg-red-200">destructive ghost</p>
      {/* destructive ghost */}
      <div className="mt-8 flex flex-wrap gap-3 ">
        <Button variant="destructiveGhost" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructiveGhost" size="lg">
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructiveGhost" size="lg" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveGhost" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveGhost" size="sm" iconOnly>
          <BoxIcon />
        </Button>

        <Button variant="destructiveGhost" size="lg">
          <BoxIcon /> <ButtonText>Button-lg</ButtonText>
          <BoxIcon />
        </Button>
        <Button variant="destructiveGhost">
          <BoxIcon className="" /> <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveGhost" size="sm">
          <BoxIcon className="" /> <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructiveGhost" size="lg" loading>
          <ButtonText>Button-lg</ButtonText>
        </Button>

        <Button variant="destructiveGhost" size="lg" loading iconOnly></Button>

        <Button variant="destructiveGhost" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveGhost" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        <Button variant="destructiveGhost" size="lg" disabled>
          <ButtonText>Button-lg</ButtonText>
        </Button>
        <Button className="" variant="destructiveGhost" disabled>
          <ButtonText>Button-md</ButtonText>
        </Button>
        <Button variant="destructiveGhost" size="sm" disabled>
          <ButtonText>Button-sm</ButtonText>
        </Button>
      </div>
      {/* destructive end */}
    </div>
  )
}
